
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 17.98 18"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{staticClass:"a",attrs:{"d":"M17.817 17.04l-4.95-4.976a7.33 7.33 0 10-.795.796l4.946 4.974a.563.563 0 10.799-.794zM7.325 13.474a6.16 6.16 0 01-6.166-6.155v-.005a6.16 6.16 0 116.166 6.16z"}})])
          )
        }
      }
    